import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function TrendingIndustrySignals({ trendingIndustrySignals }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     trending_industry: "a",
  //     active_competitors: "b",
  //     momentum: "c",
  //     sample_expansions: "d",
  //     overlap_risk_to_cardinal: "e",
  //     why_risk_is_high: "e",
  //     active_competitors_positive_insight: "b",
  //     active_competitors_negative_insight: "b",
  //     active_competitors_recent_development: "b",
  //     momentum_positive_insight: "c",
  //     momentum_negative_insight: "c",
  //     momentum_recent_development: "c",
  //     sample_expansions_positive_insight: "d",
  //     sample_expansions_negative_insight: "d",
  //     sample_expansions_recent_development: "d",
  //     overlap_risk_to_cardinal_positive_insight: "e",
  //     overlap_risk_to_cardinal_negative_insight: "e",
  //     overlap_risk_to_cardinal_recent_development: "e",
  //     why_risk_is_high_positive_insight: "e",
  //     why_risk_is_high_negative_insight: "e",
  //     why_risk_is_high_recent_development: "e",
  //   },
  //   {
  //     trending_industry: "a",
  //     active_competitors: "b",
  //     momentum: "c",
  //     sample_expansions: "d",
  //     overlap_risk_to_cardinal: "e",
  //     why_risk_is_high: "e",
  //     active_competitors_positive_insight: "b",
  //     active_competitors_negative_insight: "b",
  //     active_competitors_recent_development: "b",
  //     momentum_positive_insight: "c",
  //     momentum_negative_insight: "c",
  //     momentum_recent_development: "c",
  //     sample_expansions_positive_insight: "d",
  //     sample_expansions_negative_insight: "d",
  //     sample_expansions_recent_development: "d",
  //     overlap_risk_to_cardinal_positive_insight: "e",
  //     overlap_risk_to_cardinal_negative_insight: "e",
  //     overlap_risk_to_cardinal_recent_development: "e",
  //     why_risk_is_high_positive_insight: "e",
  //     why_risk_is_high_negative_insight: "e",
  //     why_risk_is_high_recent_development: "e",
  //   },
  //   {
  //     trending_industry: "a",
  //     active_competitors: "b",
  //     momentum: "c",
  //     sample_expansions: "d",
  //     overlap_risk_to_cardinal: "e",
  //     why_risk_is_high: "e",
  //     active_competitors_positive_insight: "b",
  //     active_competitors_negative_insight: "b",
  //     active_competitors_recent_development: "b",
  //     momentum_positive_insight: "c",
  //     momentum_negative_insight: "c",
  //     momentum_recent_development: "c",
  //     sample_expansions_positive_insight: "d",
  //     sample_expansions_negative_insight: "d",
  //     sample_expansions_recent_development: "d",
  //     overlap_risk_to_cardinal_positive_insight: "e",
  //     overlap_risk_to_cardinal_negative_insight: "e",
  //     overlap_risk_to_cardinal_recent_development: "e",
  //     why_risk_is_high_positive_insight: "e",
  //     why_risk_is_high_negative_insight: "e",
  //     why_risk_is_high_recent_development: "e",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(trendingIndustrySignals);
    setTabData(tableData);
  }, [trendingIndustrySignals]);

  // Columns for GenericTable
  const tableColumns = [
    { key: "trending_industry", label: "Trending Industry" },
    { key: "active_competitors", label: "Active Competitors" },
    { key: "momentum", label: "Momentum" },
    { key: "sample_expansions", label: "Expansions" },
    { key: "overlap_risk_to_user_company", label: "Overlap Risk To Company" },
    { key: "why_risk_is_high", label: "Why Risk Is High" },
  ];

  return (
    <InsightTable
      title="Trending Industry Signals"
      subtitle="Identify fast-moving markets and care segments based on recent expansion signals, activity momentum, and competitive intensity."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier={[]}
      actions={actions}
    />
  );
}

export default TrendingIndustrySignals;
